export const safeStorage = {
  getItem(key: string): string | null {
    if (typeof window === 'undefined') return null
    try {
      return window.localStorage.getItem(key)
    } catch {
      return null
    }
  },

  setItem(key: string, value: string): boolean {
    if (typeof window === 'undefined') return false
    try {
      window.localStorage.setItem(key, value)
      return true
    } catch (error) {
      console.warn('[safe-storage] setItem failed', error)
      return false
    }
  },

  removeItem(key: string): void {
    if (typeof window === 'undefined') return
    try {
      window.localStorage.removeItem(key)
    } catch {}
  },
}
